import { useQuery } from "@tanstack/react-query";

interface UseFeatureToggleProps {
  flagKey: string;
  flagType?: "boolean" | "variant" | "batch";
  entityId?: string;
  namespaceKey?: string;
}

const fetchFeatureFlagValidation = (props: UseFeatureToggleProps) => async () => {
  try {
    const url = "/api/feature-toggle";
    const body = JSON.stringify(props);
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body
    });
    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error sending GET request:", error); // TODO: log error to error tracking service
    throw error;
  }
};

const useFeatureToggle = ({
  flagKey,
  flagType,
  entityId,
  namespaceKey
}: UseFeatureToggleProps) => {
  const {
    data,
    error,
    isError,
    isLoading,
    isSuccess,
    status
  } = useQuery({
    queryKey: ["FEATURE_FLAG", flagKey],
    queryFn: fetchFeatureFlagValidation({
      flagKey,
      flagType,
      entityId,
      namespaceKey
    })
  });
  const isEnabled = status === "success" ? Boolean(data?.enabled) : false;

  return {
    isEnabled,
    error,
    isError,
    isLoading,
    isSuccess,
    status
  };
};

export default useFeatureToggle;
